import { render, staticRenderFns } from "./LISLogicalLocation.vue?vue&type=template&id=f6c4282a&scoped=true"
import script from "./LISLogicalLocation.vue?vue&type=script&lang=js"
export * from "./LISLogicalLocation.vue?vue&type=script&lang=js"
import style0 from "./LISLogicalLocation.vue?vue&type=style&index=0&id=f6c4282a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c4282a",
  null
  
)

export default component.exports